import { constants, mediaQueryStyles } from "@newsela/angelou";

import { AssignModalZIndex } from "@/view/AssignModal/AssignModal.style";
const { mediaQuery } = mediaQueryStyles;

const { breakpoints } = constants;
const { BreakpointNames } = breakpoints;

export const modalZIndex = AssignModalZIndex;

export const modalRootCss = {
  zIndex: modalZIndex,
};

export const modalContentWrapperCss = {
  height: "auto",
};

export const modalBodyCss = {
  flexGrow: "1",
  [mediaQuery.downTo(BreakpointNames.xs)]: {
    padding: "32px",
  },
};

export const modalFooterCss = {
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
};
